{
  "asset_id": "d181abcb-a481-44bf-b122-dafa5a4438d0",
  "content_type": "image/png",
  "created_at": "2026-06-26T13:31:09Z",
  "original_filename": "plan-bonus.png",
  "project_id": "1ee18af1-1d84-490c-8b4d-f96ad9f331fc",
  "r2_key": "a/v1/1ee18af1-1d84-490c-8b4d-f96ad9f331fc/d181abcb-a481-44bf-b122-dafa5a4438d0/plan-bonus.png",
  "size": 370957,
  "url": "/__l5e/assets-v1/d181abcb-a481-44bf-b122-dafa5a4438d0/plan-bonus.png",
  "version": 1
}